import styled from '@emotion/styled';

const GalleryImageNumber = styled('div')(({ theme }) => ({
  fontWeight: theme.fonts.weight.medium,
}));

export default GalleryImageNumber;
